const api_base = ["http://localhost", "https://api.training.shelter.co.id"];

const host = process.env.NODE_ENV === "development" ? 0 : 1;
const API_BASE_URL = api_base[host];
const RESOURCE_URL = `${API_BASE_URL}/static`;

const constants = {
  // Backend API endpoints
  API_BASE_URL: API_BASE_URL,
  IMG_URL: RESOURCE_URL + "/img/",
  FILE_TES_URL: RESOURCE_URL + "/file_tes/",
  PHOTO_PROFIL_URL: RESOURCE_URL + "/photo_profil/",
  PHOTO_TRAINING_URL: RESOURCE_URL + "/photo_kegiatan/",
  // Key for local storage
  STORAGE_KEY: "shelterTraining_",
  // VUE PICTURE INPUT plugin
  VUE_PICTURE_INPUT: {
    upload: "<p>Perangkat Anda tidak mendukung <b>file uploading</b>.</p>", // HTML allowed
    drag: "Geser ke sini atau <br>klik untuk memilih Photo", // HTML allowed
    tap: "Sentuh disini untuk memilih Photo <br>dari galeri Anda.", // HTML allowed
    change: "Ganti Photo", // Text only
    selected: "<p>Photo berhasil dipilih!</p>", // HTML allowed
    fileType: "Tipe file tidak didukung!." // Text only
  },
  // FORMAT FOR TABLE FILTER
  FORMAT: {
    options: "options",
    text: "text",
    number: "number",
    date: "date",
    datetime: "datetime",
    text_options: "text_options"
  }
};

export default constants;
